export function getSession(data) {
    return {
        type: "GET_SESSION",
        payload: {
            data: data,
        }
    };
};
